<template>
    <app-layout :title="trans('vehicles.page_title.edit')">
        <template #header> {{ trans("vehicles.page_title.edit") }} </template>

        <Section>
            <Container>
                <form @submit.prevent="form.post(url)" id="form">
                    <div
                        class="space-y-8 divide-y divide-gray-200 sm:space-y-5"
                    >
                        <div class="space-y-6 sm:space-y-5">
                            <div class="space-y-6 sm:space-y-5">
                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="image"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.image") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <ImageUploader
                                            :name="form.make"
                                            :preselected-image="form.image"
                                            class="mt-1"
                                            @selected="
                                                (image) => (form.image = image)
                                            "
                                            @removed="form.image = null"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors?.image"
                                        >
                                            <strong>{{
                                                form.errors?.image
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="type"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.type") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <select
                                            name="type"
                                            id="type"
                                            v-model="form.type"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.type,
                                                },
                                            ]"
                                        >
                                            <option value="">Auswählen</option>
                                            <option value="car">PKW</option>
                                            <option value="truck">LKW</option>
                                            <option value="oldtimer">
                                                Oldtimer
                                            </option>
                                        </select>
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.type"
                                        >
                                            <strong>{{
                                                form.errors.type
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="make"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.make") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="make"
                                            id="make"
                                            v-model="form.make"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.make,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.make"
                                        >
                                            <strong>{{
                                                form.errors.make
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="model"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.model") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="model"
                                            id="model"
                                            v-model="form.model"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.model,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.model"
                                        >
                                            <strong>{{
                                                form.errors.model
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        form.type == 'car' ||
                                        form.type == 'oldtimer'
                                    "
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="gearbox"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.gearbox") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <select
                                            name="gearbox"
                                            id="gearbox"
                                            v-model="form.gearbox"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.gearbox,
                                                },
                                            ]"
                                        >
                                            <option value="">Auswählen</option>
                                            <option value="automatic">
                                                Automatik
                                            </option>
                                            <option value="manual">
                                                Schaltgetriebe
                                            </option>
                                            <option value="half-automatic">
                                                Halbautomatik
                                            </option>
                                        </select>
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.gearbox"
                                        >
                                            <strong>{{
                                                form.errors.gearbox
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        form.type == 'car' ||
                                        form.type == 'oldtimer'
                                    "
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="seats"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.seats") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="seats"
                                            id="seats"
                                            v-model="form.seats"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.seats,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.seats"
                                        >
                                            <strong>{{
                                                form.errors.seats
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        form.type == 'car' ||
                                        form.type == 'oldtimer'
                                    "
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="baggage"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.baggage") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="baggage"
                                            id="baggage"
                                            v-model="form.baggage"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.baggage,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.baggage"
                                        >
                                            <strong>{{
                                                form.errors.baggage
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    v-if="form.type == 'truck'"
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="height"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.height") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="height"
                                            id="height"
                                            v-model="form.height"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.height,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.height"
                                        >
                                            <strong>{{
                                                form.errors.height
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    v-if="form.type == 'truck'"
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="length"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.length") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="length"
                                            id="length"
                                            v-model="form.length"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.length,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.length"
                                        >
                                            <strong>{{
                                                form.errors.length
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="plate"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{ trans("vehicles.label.plate") }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="plate"
                                            id="plate"
                                            v-model="form.plate"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors.plate,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="form.errors.plate"
                                        >
                                            <strong>{{
                                                form.errors.plate
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="workday_hourly_price"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{
                                            trans(
                                                "vehicles.label.workday_hourly_price"
                                            )
                                        }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="workday_hourly_price"
                                            id="workday_hourly_price"
                                            v-model="form.workday_hourly_price"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors
                                                            .workday_hourly_price,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="
                                                form.errors.workday_hourly_price
                                            "
                                        >
                                            <strong>{{
                                                form.errors.workday_hourly_price
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="workday_daily_price"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{
                                            trans(
                                                "vehicles.label.workday_daily_price"
                                            )
                                        }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="workday_daily_price"
                                            id="workday_daily_price"
                                            v-model="form.workday_daily_price"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors
                                                            .workday_daily_price,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="
                                                form.errors.workday_daily_price
                                            "
                                        >
                                            <strong>{{
                                                form.errors.workday_daily_price
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="weekend_hourly_price"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{
                                            trans(
                                                "vehicles.label.weekend_hourly_price"
                                            )
                                        }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="weekend_hourly_price"
                                            id="weekend_hourly_price"
                                            v-model="form.weekend_hourly_price"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors
                                                            .weekend_hourly_price,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="
                                                form.errors.weekend_hourly_price
                                            "
                                        >
                                            <strong>{{
                                                form.errors.weekend_hourly_price
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>

                                <div
                                    class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                                >
                                    <label
                                        for="weekend_daily_price"
                                        class="block font-medium text-gray-700 sm:mt-px sm:pt-2"
                                    >
                                        {{
                                            trans(
                                                "vehicles.label.weekend_daily_price"
                                            )
                                        }}
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <input
                                            type="text"
                                            name="weekend_daily_price"
                                            id="weekend_daily_price"
                                            v-model="form.weekend_daily_price"
                                            class="block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                                            :class="[
                                                {
                                                    'border border-red-500':
                                                        form.errors
                                                            .weekend_daily_price,
                                                },
                                            ]"
                                        />
                                        <small
                                            class="text-red-500"
                                            v-if="
                                                form.errors.weekend_daily_price
                                            "
                                        >
                                            <strong>{{
                                                form.errors.weekend_daily_price
                                            }}</strong>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-8 sm:mt-0 pt-8 flex justify-end">
                            <button type="submit">
                                <StyledButton background-primary>{{
                                    trans("button.submit")
                                }}</StyledButton>
                            </button>
                        </div>
                    </div>
                </form>
            </Container>
        </Section>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import StyledButton from "@/Components/StyledButton.vue";
import Container from "@/Components/Container.vue";
import Section from "@/Components/Section.vue";
import { Link } from "@inertiajs/inertia-vue3";
import ImageUploader from "@/Components/ImageUploader.vue";

export default {
    components: {
        AppLayout,
        StyledButton,
        Link,
        Container,
        Section,
        ImageUploader,
    },

    props: {
        vehicle: Object,
        url: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: this.vehicle?.id ? "put" : "post",
                type: this.vehicle?.type ?? "",
                make: this.vehicle?.make ?? "",
                model: this.vehicle?.model ?? "",
                plate: this.vehicle?.plate ?? "",
                workday_hourly_price: this.vehicle?.workday_hourly_price ?? "",
                workday_daily_price: this.vehicle?.workday_daily_price ?? "",
                weekend_hourly_price: this.vehicle?.weekend_hourly_price ?? "",
                weekend_daily_price: this.vehicle?.weekend_daily_price ?? "",
                image: this.vehicle?.image ?? "",
                gearbox: this.vehicle?.gearbox ?? "",
                seats: this.vehicle?.seats ?? "",
                baggage: this.vehicle?.baggage ?? "",
                height: this.vehicle?.height ?? "",
                length: this.vehicle?.length ?? "",
            }),
        };
    },
};
</script>
